import React, { useState, useEffect } from 'react'
import Modal from '../../modals/modules/Modal'
import SnackbarMessage from '../../messages/modules/SnackbarMessage'
import { isUnderMaintenance } from '../../theme-structure/services/api'

import { Box, Typography, Chip, Divider } from '@material-ui/core'

function MaintenanceBanner({route_key}) {
    const [um, setUm] = useState({})

    const fetchMaintenanceStatus = async () => {
        const data = await isUnderMaintenance()
        setUm(data)
    }

    useEffect(() => {
        fetchMaintenanceStatus()
    }, [route_key])

    const {
        is_undermaintenance = false,
        since = '',
        to = '',
        is_in_timeframe = false,
        is_excluded = true
    } = um

    const show_modal = is_undermaintenance
    const show_warning = is_in_timeframe && is_excluded

    return (
        <>
            <Modal
                open={show_modal}
                disableBackdropClick
                title="UNDER MAINTENANCE"
                content={
                    <Box>
                        <Box>
                            <Typography component="span" variant="body2">
                                App is currently down for maintenance.
                                <br />
                                Thanks for your patience.
                            </Typography>
                        </Box>
                        <Box mt={2} mb={2}>
                            <Divider />
                        </Box>
                        <Box mt={2} mb={1}>
                            <Chip label={"Since: " + since} size="small" variant="outlined" />
                        </Box>
                        <Box mb={1}>
                            <Chip label={"To: " + to} size="small" variant="outlined" />
                        </Box>
                    </Box>
                }
            />
            {!!show_warning && (
                <SnackbarMessage
                    severity="warning"
                    open={true}
                    anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
                    persistentDuration
                    message="System is under maintenance"
                />
            )}
        </>
    )
}

export default MaintenanceBanner
